import { render, staticRenderFns } from "./SelectStructure.vue?vue&type=template&id=3b0f4f8c"
import script from "./SelectStructure.vue?vue&type=script&lang=js"
export * from "./SelectStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports